var Global = {
    // Develop
    //api: 'http://localhost:3000',

    // Production
    api: 'https://consejo-fif.uaq.mx'
}

export default Global;